<template>
	<main>
		<div
			:style="getCardInlineStyle()"
			class="streaks-card"
		>
			<main class="w-100 py-3" v-if="shimmerStreak">
				<Spinner :id="'streak'" class="h-100"></Spinner>
			</main>
			<template v-else>
				<section
					v-if="streakMonthCount < 3 && !isMobileViewport"
					:class="
						streakMonthCount == 1
							? 'w-50'
							: streakMonthCount == 2
							? 'width-35 d-flex flex-column justify-content-between'
							: ''
					"
				>
					<div class="d-flex align-items-center myp-black-txt-3 ">
						<img
							class="mr-2"
							src="../../assets/newdesign/home/streakicon.svg"
							alt=""
						/>Streaks
					</div>

					<h3 v-if="streakMonthCount == 1" class="myp-grey-txt-5 mt-3">
						A short instruction/Context on how this streak activity works to
						explain to new users.
					</h3>
					<h3 v-if="streakMonthCount == 2" class="myp-grey-txt-5 mt-3">
						Your past 2 months activity can be found here
					</h3>
					<div class="activity-txt">Activity :</div>
					<img
						v-if="streakMonthCount == 1"
						class="mt-2"
						src="../../assets/newdesign/myprofile/streaksVariant.svg"
						alt=""
					/>
				</section>
				<!-- w-100 if 3 else w-50 -->

				<section
					:class="
						streakMonthCount == 1
							? 'w-50'
							: streakMonthCount == 1
							? 'w65'
							: 'w-100'
					"
					class="d-flex flex-column align-items-center"
				>
					<!-- <div class="streak-head">
				{{ formatDateStreak(streakData[0]) }}
			</div> -->
					<!-- IF 1: PL5 else pl1  -->
					<main
						v-if="streakMonthCount > 2 || isMobileViewport"
						class="d-flex align-items-center w-100 mb-3 justify-content-between dotted-bottom"
					>
						<article class="d-flex align-items-center myp-black-txt-3">
							<img
								class="mr-2"
								src="../../assets/newdesign/home/streakicon.svg"
								alt=""
							/>Streaks
						</article>

					</main>
				<!-- ── Desktop heatmap: clip box + slide arrows ── -->
				<template v-if="!isMobileViewport">
					<div class="heatmap-slide-wrapper" :class="streakMonthCount < 3 ? 'pl-5' : ''">
						<!-- overflow:hidden clips to 6-month width; inner SVG translates for slide -->
						<div class="heatmap-clip-box">
							<div id="heatmap2" style="width: 100%; position: relative;"></div>
						</div>
						<!-- Arrows absolutely positioned over the clip box -->
						<button
							v-if="leftArrow || rightArrow"
							@click="onPrevArrowClick()"
							class="heatmap-arrow heatmap-arrow-left"
							:disabled="!leftArrow || loadingGraph"
							aria-label="Previous months"
						>
							<svg width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M9 1L1 8L9 15" stroke="#20639B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
						</button>
						<button
							v-if="leftArrow || rightArrow"
							@click="onNextArrowClick()"
							class="heatmap-arrow heatmap-arrow-right"
							:disabled="!rightArrow || loadingGraph"
							aria-label="Next months"
						>
							<svg width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M1 1L9 8L1 15" stroke="#20639B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
						</button>
					</div>
				</template>

				<!-- ── Mobile heatmap: horizontal scroll strip + progress bar ── -->
				<template v-else>
					<div id="mobile-heatmap-scroll" ref="mobileHeatmapScroll" class="mobile-heatmap-scroll" @touchstart.passive="onHeatmapTouchStart">
						<div id="heatmap2" class="mobile-heatmap-inner"></div>
					</div>
					<!-- Horizontal scroll slider -->
					<HorizontalScroll
						scrollContainerId="mobile-heatmap-scroll"
						:scrollContainerRef="mobileHeatmapScrollEl"
						:dataList="bufferedStreakData"
						parentClass="mobile-heatmap-slider-wrap"
					/>
				</template>

					<!-- Bottom Activities List (Paginated) -->
					<div class="streak-activities-list w-100 mt-4" style="max-width: 900px; margin: 0 auto; border-top: 1px solid #e2e8f0; padding-top: 24px;">
						<!-- Header -->
						<div class="d-flex justify-content-between align-items-center mb-4">
							<div>
								<div class="streak-date-text" style="font-family: Montserrat; font-weight: 600; font-size: 16px; color: #1e3a8a;">
									{{ formattedDay }}<sup style="font-size: 10px;">{{ dayOrdinal }}</sup> {{ formattedMonthParts.firstChar }}{{ formattedMonthParts.restChars }} {{ formattedMonthParts.year }}
								</div>
								<div class="streak-activities-count mt-1" style="font-family: Montserrat; font-size: 11px; font-weight: 700; color: #a0aec0; text-transform: uppercase;">
									<b-skeleton v-if="shimmerActivities" width="60px" height="14px"></b-skeleton>
									<template v-else>{{ todayTotalCount }} {{ todayTotalCount === 1 ? 'ACTIVITY' : 'ACTIVITIES' }}</template>
								</div>
							</div>
							<div class="d-flex gap-2" v-if="totalPages > 1 && !shimmerActivities">
								<button @click="prevPage" :disabled="currentPage === 1" class="btn btn-sm p-0 streak-page-btn" style="background: transparent; border: none;" :style="currentPage === 1 ? { opacity: '0.4' } : {}">
									<img src="../../assets/LeftStreakArrow.svg" alt="Previous" width="40" height="40" />
								</button>
								<button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-sm p-0 streak-page-btn" style="background: transparent; border: none;" :style="currentPage === totalPages ? { opacity: '0.4' } : {}">
									<img src="../../assets/RightStreakArrow.svg" alt="Next" width="40" height="40" />
								</button>
							</div>
						</div>

						<!-- Shimmer skeleton while loading activity list -->
						<div v-if="shimmerActivities">
							<div v-for="n in 3" :key="'skel-' + n" class="streak-stat-row py-3" style="border-bottom: 2px dashed #f1f5f9; display: flex; align-items: center;">
								<div class="act-shimmer-circle mr-3"></div>
								<div class="act-shimmer-line" :style="{ width: (45 + n * 8) + '%' }"></div>
							</div>
						</div>

						<!-- List -->
						<div v-else-if="paginatedStats.length > 0">
							<div v-for="(stat, i) in paginatedStats" :key="i" class="streak-stat-row py-3" style="border-bottom: 2px dashed #f1f5f9; display: flex; align-items: center;">
								<div class="streak-stat-icon-wrap mr-3" style="width: 32px; height: 32px; flex-shrink: 0; display: flex; align-items: center; justify-content: center;">
									<img :src="getActivityIcon(stat.logType)" width="32" height="32" alt="" style="border-radius: 50%; object-fit: cover;" />
								</div>
								<p class="streak-stat-text mb-0" style="font-family: Montserrat; font-size: 14px; font-weight: 500; color: #334155;">
									<strong v-if="stat.showCount" style="color: #1e3a8a;">{{ stat.count }}</strong>
									<span v-if="stat.showCount">&nbsp;</span>
									<span>{{ stat.label }}</span>
								</p>
							</div>
						</div>
						<div v-else class="text-center py-5">
							<img :src="noActivityIcon" width="74" height="77" alt="No activity" />
							<p class="mt-3 text-muted" style="font-family: Montserrat; font-size: 14px; font-weight: 500;">No activity found</p>
						</div>
						<!-- end v-if shimmerActivities / paginatedStats / empty -->
					</div>

				</section>
			</template>
		</div>
	</main>
</template>

<script>
import { profileHeatmap } from "../../utils/profileHeatmap.js";
import { getProfileStreak as apiGetProfileStreak } from "../../utils/apiFunctions.js";
import Spinner from "../fixedcomponents/Spinner.vue";
import HorizontalScroll from "../fixedcomponents/HorizontalScroll.vue";

async function getProfileStreak(payload) {
	const resp = await apiGetProfileStreak(payload);
	if (resp.status === 200 && payload.duration > 6) {
		const [year, month] = payload.startDate.split("-").map(Number);
		const date = new Date(year, month - 1, 1);
		date.setMonth(date.getMonth() + 6);
		const nextStartDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
		
		const payload2 = { ...payload, startDate: nextStartDate, duration: payload.duration - 6 };
		try {
			const resp2 = await apiGetProfileStreak(payload2);
			if (resp2.status === 200 && resp2.data?.data?.data) {
				if (Array.isArray(resp.data.data.data) && Array.isArray(resp2.data.data.data)) {
					const existingMonths = new Set();
					resp.data.data.data.forEach(item => {
						existingMonths.add(`${item.year}-${Number(item.month)}`);
					});
					const uniqueNewData = resp2.data.data.data.filter(item => !existingMonths.has(`${item.year}-${Number(item.month)}`));
					resp.data.data.data = [...resp.data.data.data, ...uniqueNewData];
				}
			}
		} catch(e) {}
	}
	return resp;
}

export default {
	components: {
		Spinner,
		HorizontalScroll,
	},
	data() {
		const today = new Date();
		const defaultDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
		return {
			streakData: [],
			bufferedStreakData: [],
			viewOffset: 1,
			startDate: "",
			streakMonthCount: null,
			leftArrow: false,
			rightArrow: false,
			earliestAllowedMonthKey: null,
			accountCreatedAt: null,
			shimmerStreak: true,
			isSliding: false,
			slideClass: "",
			slideDirection: "left",
			_refreshDebounce: null,
			_pendingSlideOnDone: null,
			monthKey: null,
			isMobileViewport: window.innerWidth <= 768,
			activeStreakIcon: require("../../assets/newdesign/landing/ok.svg"),
			inactiveStreakIcon: null,
			noActivityIcon: require("../../assets/noActivityIcon.svg"),
			activityIconAssessment: require("../../assets/ActivityAssessment.png"),
			activityIconProfileEdit: require("../../assets/ActivityProfileEdit.svg"),
			shimmerActivities: false,
			stats: [],
			todayTotalCount: 0,
			currentPage: 1,
			itemsPerPage: 3,
			selectedDate: defaultDate,
			// Mobile scroll state
			_activityFetching: false,
			mobileScrollLeft: 0,
			mobileScrollWidth: 1,
			mobileClientWidth: 1,
			_mobileScrollListener: null,
			_mobileScrollFetching: false,
			_mobileMonthPx: 0,
			_mobileScrollStopTimer: null,
			_mobileScrollLastX: 0,
			_mobileScrollLastT: 0,
			_mobileShimmerTimer: null,
			mobileScrollFast: false,
			_mobileScrolling: false,
			mobileHeatmapScrollEl: null,
		};
	},
	computed: {
		paginatedStats() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const end = start + this.itemsPerPage;
			return this.stats.slice(start, end);
		},
		totalPages() {
			return Math.ceil(this.stats.length / this.itemsPerPage);
		},
		formattedDay() {
			const [year, month, day] = this.selectedDate.split('-');
			return new Date(year, month - 1, day).getDate();
		},
		dayOrdinal() {
			const [year, month, day] = this.selectedDate.split('-');
			const d = new Date(year, month - 1, day).getDate();
			if (d >= 11 && d <= 13) return 'th';
			switch (d % 10) {
				case 1: return 'st';
				case 2: return 'nd';
				case 3: return 'rd';
				default: return 'th';
			}
		},
		formattedMonthParts() {
			const [year, month, day] = this.selectedDate.split('-');
			const dateStr = new Date(year, month - 1, day).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
			const parts = dateStr.split(' ');
			return {
				firstChar: (parts[0] || '').charAt(0),
				restChars: (parts[0] || '').slice(1),
				year: parts[1] || ''
			};
		}
	},
	async created() {
		// If navigated from the home streak card with a specific date, pre-select and scroll to it
		const queryDate = this.$route?.query?.date;
		if (queryDate && /^\d{4}-\d{2}-\d{2}$/.test(queryDate)) {
			this.selectedDate = queryDate;
			this._scrollToDateAfterRender = queryDate;
		}
		this.startDate = await this.firstDate();
		this.getStreakGraph();
	},
	mounted() {
		window.addEventListener("resize", this.handleViewportResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleViewportResize);
	},
	methods: {
		// Computes earliestAllowedMonthKey from the account creation date stored in Vuex.
		// Rule: account creation month − 6 months.
		// E.g. account created June 2025 → earliest allowed = December 2024.
		_computeEarliestAllowedMonth() {
			try {
				const raw = this.accountCreatedAt || null;
				if (!raw) {
					this.earliestAllowedMonthKey = null;
					return;
				}
				const createdDate = new Date(raw);
				if (isNaN(createdDate.getTime())) {
					this.earliestAllowedMonthKey = null;
					return;
				}
				// Earliest allowed = January of the account creation year
				// e.g. account created June 2022 → earliest = 2022-01
				const year = createdDate.getFullYear();
				this.earliestAllowedMonthKey = `${year}-01`;
			} catch (e) {
				this.earliestAllowedMonthKey = null;
			}
		},
		// Returns true if we can still navigate backwards (i.e. firstKey > earliestAllowedMonthKey)
		_canGoFurther(firstVisibleMonthKey) {
			if (!this.earliestAllowedMonthKey) return true;
			return firstVisibleMonthKey > this.earliestAllowedMonthKey;
		},
		getActivityIcon(logType) {
			// Assessment-related logTypes: 42 (assessment), 43 (mock interview), 45 (interview), 52 (course published)
			const assessmentTypes = new Set([42, 43, 44, 45, 51, 52]);
			if (assessmentTypes.has(Number(logType))) {
				return this.activityIconAssessment;
			}
			// Default to profile edit icon for profile-related and other activities
			return this.activityIconProfileEdit;
		},
		prevPage() {
			if (this.currentPage > 1) this.currentPage--;
		},
		nextPage() {
			if (this.currentPage < this.totalPages) this.currentPage++;
		},
		getHeatmapLayoutParams(isMobile, mobileMonthCount) {
			// mobileMonthCount is only used on mobile scroll mode to render all months in one row
			const monthLimit = isMobile ? (mobileMonthCount || 8) : 6;
			let numOfCol = 1;
			let cellSize = 0;
			let widthVal = 0;
			let monthGap = 7;
			let perRowCell = 6;
			let cellGap = 1.8;
			let x_axis_cellGap = 1.8;
			let y_axis_cellGap = 1.8;
			const laptop = window.innerWidth >= 1024;

			if (!isMobile) {
				// ── Desktop layout (unchanged) ──────────────────────────────────
				if (monthLimit == 1) {
					numOfCol = 1;
					cellSize = 4;
					widthVal = window.innerWidth < 1450 ? 45 : 55;
					if (!laptop) cellSize = 5;
				} else if (monthLimit == 2) {
					numOfCol = 2;
					cellSize = 4.5; widthVal = 90; perRowCell = 5;
				} else if (monthLimit == 3) {
					numOfCol = 3; cellSize = 5; widthVal = 140;
				} else {
					numOfCol = monthLimit; cellSize = 3.35; widthVal = 235;
					monthGap = 5.4; perRowCell = 6; cellGap = 1.4;
					x_axis_cellGap = 1.6; y_axis_cellGap = 1.5;
					if (window.innerWidth < 1450) { cellSize = 3.1; widthVal = 225; monthGap = 4.8; }
					if (window.innerWidth < 1280) { cellSize = 2.9; widthVal = 220; monthGap = 4.2; x_axis_cellGap = 1.45; y_axis_cellGap = 1.35; }
					if (!laptop) { cellSize = 2.7; widthVal = 205; monthGap = 3.8; }
				}
			} else {
				// ── Mobile scroll layout ─────────────────────────────────────────
				// All N months rendered in a single horizontal row (numOfCol = N).
				// The SVG viewBox is wide enough for all months; the container scrolls.
				const n = monthLimit; // number of months to show (up to 8)
				numOfCol = n;
				cellSize = 5.2;
				perRowCell = 6;
				cellGap = 1.25;
				x_axis_cellGap = 1.4;
				y_axis_cellGap = 1.4;
				monthGap = 6;
				// widthVal = total width of one-row strip for all n months
				const oneMonthBlockWidth = perRowCell * cellSize + (perRowCell - 1) * x_axis_cellGap;
				widthVal = n * oneMonthBlockWidth + (n - 1) * monthGap + 4; // +4 for margin
				// Return per-month width so callers can size the 2-month viewport
				return { numOfCol, cellSize, widthVal, monthGap, perRowCell, cellGap, x_axis_cellGap, y_axis_cellGap, oneMonthBlockWidth };
			}
			return { numOfCol, cellSize, widthVal, monthGap, perRowCell, cellGap, x_axis_cellGap, y_axis_cellGap };
		},
		onHeatmapTouchStart() {
			// Pre-emptively lock the parent's scroll state the instant the user
			// touches the heatmap area.  This fires BEFORE any scroll events,
			// preventing the week heatmap from toggling during the touch.
			// The short 600ms lock is enough to cover the touchstart→click
			// sequence; onCellClick will extend it if a cell is actually tapped.
			let p = this.$parent;
			while (p) {
				if (typeof p.lockScrollState === 'function') {
					p.lockScrollState(600);
					break;
				}
				p = p.$parent;
			}
		},
		onCellClick(dateStr, isFromWeekHeatmap = false) {
			// Debounce guard: on mobile, touchend + click can both fire for
			// the same tap.  Skip the duplicate within a 400ms window.
			const now = Date.now();
			if (this._lastCellClickDate === dateStr && now - (this._lastCellClickTime || 0) < 400) {
				return;
			}
			this._lastCellClickDate = dateStr;
			this._lastCellClickTime = now;

			// Check if we need to do a full reload because the month is out of bounds
			const targetMonthKey = dateStr.substring(0, 7);
			const allKeys = this.getBufferedMonthKeys();
			let needsFullReload = false;
			
			if (isFromWeekHeatmap) {
				if (allKeys.indexOf(targetMonthKey) === -1) {
					needsFullReload = true;
					const [y, m] = targetMonthKey.split('-').map(Number);
					this.startDate = this.getSixMonthsBackDate(y, m, this.isMobileViewport ? 7 : 6);
				}
			}

			// Lock the parent StreakPage's scroll state so the week heatmap
			// doesn't snap back into view during the re-render reflow.
			// Use a generous timeout to cover slow API responses; it will be
			// released early once getStreakGraph completes.
			let p = this.$parent;
			while (p) {
				if (typeof p.lockScrollState === 'function') {
					p.lockScrollState(3000);
					break;
				}
				p = p.$parent;
			}

			// If a previous request is still in-flight (shimmerActivities already true),
			// show the heatmap shimmer to signal the spam. Otherwise fetch silently.
			const wasAlreadyLoading = this.shimmerActivities;
			this.selectedDate = dateStr;
			this.currentPage = 1;
			this.shimmerActivities = true;
			if (wasAlreadyLoading) {
				// Spam case: render shimmer heatmap overlay so the user sees feedback
				const isMobile = this.isMobileViewport;
				const layout = this.getHeatmapLayoutParams(isMobile);
				const margin = isMobile
					? { top: 8, right: 5, bottom: 8, left: 2 }
					: { top: 8, right: 5, bottom: 1, left: 2 };
				const shimmer = new profileHeatmap();
				shimmer.shimmerHeatmap(
					this.streakData,
					layout.numOfCol,
					layout.cellSize,
					layout.cellSize,
					margin,
					layout.widthVal,
					true,
					layout.monthGap,
					layout.perRowCell,
					layout.cellGap,
					layout.x_axis_cellGap,
					layout.y_axis_cellGap
				);
			}

			if (isFromWeekHeatmap) {
				this._scrollToDateAfterRender = dateStr;
			} else {
				this._scrollToDateAfterRender = null;
			}

			if (needsFullReload) {
				// The clicked month wasn't in the buffer, so we updated startDate
				// and need to do a full API fetch (isActivityOnly = false)
				this.getStreakGraph(false);
			} else {
				this.getStreakGraph(true);
			}
		},
		ensureMonthInView(dateStr) {
			if (!dateStr || !this.bufferedStreakData || this.bufferedStreakData.length === 0) return;
			const targetMonthKey = dateStr.substring(0, 7); // 'YYYY-MM'
			const allKeys = this.getBufferedMonthKeys();
			const targetIdx = allKeys.indexOf(targetMonthKey);
			
			if (targetIdx === -1) return;
			
			if (!this.isMobileViewport) {
				// Desktop: position the clicked month as the rightmost visible month.
				// This means viewOffset = targetIdx - visibleCount + 1, so the 6 visible
				// months end at targetIdx.
				const visibleCount = 6;
				const idealOffset = targetIdx - visibleCount + 1;
				this.viewOffset = Math.max(0, Math.min(allKeys.length - visibleCount, idealOffset));
			} else {
				// Mobile: flag target index so the scroll container will animate to it
				this._mobileTargetScrollIdx = targetIdx;
				// Perform smooth scroll after the next render tick
				this.$nextTick(() => {
					requestAnimationFrame(() => {
						this._scrollMobileToMonth(targetMonthKey);
					});
				});
			}
		},
		/**
		 * Smoothly scrolls the mobile heatmap container so that the given
		 * month (and ideally the preceding month) are visible.
		 * Mobile viewport shows ~2 months at a time, so we position the
		 * target month as the rightmost, with the prior month on the left.
		 */
		_scrollMobileToMonth(targetMonthKey) {
			const el = document.getElementById('mobile-heatmap-scroll');
			if (!el || !this._mobileMonthPx) return;

			const now = new Date();
			const currentMonthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
			const clampedKeys = [...new Set(this.bufferedStreakData
				.filter(item => {
					const key = `${item.year}-${String(item.month).padStart(2, '0')}`;
					return key <= currentMonthKey;
				})
				.map(item => `${item.year}-${String(item.month).padStart(2, '0')}`)
			)].sort();

			const targetIdx = clampedKeys.indexOf(targetMonthKey);
			if (targetIdx === -1) return;

			// Position so target month is fully visible on the right side.
			// Show the previous month on the left (2-month window).
			const monthPx = this._mobileMonthPx;
			const twoMonthsLeft = Math.max(0, (targetIdx - 1) * monthPx);
			
			// If already scrolled to this month, stay there and do not animate scroll
			if (Math.abs(el.scrollLeft - twoMonthsLeft) < 5) {
				return;
			}
			
			el.scrollTo({ left: twoMonthsLeft, behavior: 'smooth' });
			this.mobileScrollLeft = twoMonthsLeft;
		},
		getActivityLabel(item) {
			const count = Number(item?.count || 0);
			const logType = Number(item?.logType);

			switch (logType) {
				case 41:
					return "Signed in";
				case 42:
					return count === 1 ? "assessment completed" : "assessments completed";
				case 43:
					return count === 1
						? "Mock Interview Completed"
						: "Mock Interviews Completed";
				case 44:
					return count === 1
						? "job application submitted"
						: "job applications submitted";
				case 45:
					return count === 1 ? "interview completed" : "interviews completed";
				case 46:
					return count === 1 ? "resume updated" : "resumes updated";
				case 47:
					return count === 1
						? "panelist application submitted"
						: "panelist applications submitted";
				case 48:
					return count === 1 ? "Skill Practiced" : "Skills Practiced";
				case 49:
					return count === 1 ? "Skill Achieved" : "Skills Achieved";
				case 25:
				case 26:
					return "Secondary Profile Created";
				case 37:
				case 50:
					return "New Profile Created";
				case 51:
					return count === 1 ? "Interview Conducted" : "Interviews Conducted";
				case 52:
					return count === 1 ? "Course Published" : "Courses Published";
				case 53:
					return count === 1 ? "Course Completed" : "Courses Completed";
				default:
					return count === 1 ? "activity" : "activities";
			}
		},
		isMobileStreakView() {
			return window.innerWidth <= 768;
		},
		getCardInlineStyle() {
			if (this.isMobileViewport) {
				return "";
			}

			if (this.monthKey > 3) {
				return "min-height:200px;";
			}

			if (this.monthKey == 3) {
				return "min-height:247px;";
			}

			if (this.monthKey < 3) {
				return "min-height:200px;";
			}

			return "";
		},
		getPrevArrowShift() {
			return this.isMobileViewport ? 2 : 7;
		},
		getNextArrowShift() {
			return this.isMobileViewport ? -2 : -7;
		},
		getVisibleMonthKeys() {
			const unique = [];
			(this.streakData || []).forEach((item) => {
				const key = `${item.year}-${String(item.month).padStart(2, "0")}`;
				if (!unique.includes(key)) {
					unique.push(key);
				}
			});
			return unique;
		},
		getBufferedMonthKeys() {
			const unique = [];
			(this.bufferedStreakData || []).forEach((item) => {
				const key = `${item.year}-${String(item.month).padStart(2, "0")}`;
				if (!unique.includes(key)) unique.push(key);
			});
			return unique;
		},
		// Slices the buffer to visible window and renders. animate=true does a real slide.
		renderVisibleSlice(animate = false) {
			const isMobile = this.isMobileViewport;
			// On mobile, delegate entirely to the scroll renderer
			if (isMobile) {
				this.renderMobileScroll(false);
				return;
			}
			const visibleCount = 6;
			const allMonthKeys = this.getBufferedMonthKeys();
			
			const margin = isMobile
				? { top: 8, right: 5, bottom: 8, left: 2 }
				: { top: 8, right: 5, bottom: 1, left: 2 };
			const layout = this.getHeatmapLayoutParams(isMobile);

			if (animate) {
				// We need visibleCount + 1 months for the slide animation.
				let slideStartOffset;
				if (this.slideDirection === "right") {
					// We moved offset left by 1. Combined window is [viewOffset, viewOffset + visibleCount]
					slideStartOffset = this.viewOffset;
				} else {
					// We moved offset right by 1. Combined window is [viewOffset - 1, viewOffset + visibleCount - 1]
					slideStartOffset = this.viewOffset - 1;
				}
				
				const slideKeys = allMonthKeys.slice(slideStartOffset, slideStartOffset + visibleCount + 1);
				const slideKeySet = new Set(slideKeys);
				const slideData = this.bufferedStreakData.filter((item) => {
					const key = `${item.year}-${String(item.month).padStart(2, "0")}`;
					return slideKeySet.has(key);
				});

				const c = new profileHeatmap();
				c.slideHeatmap(
					slideData,
					this.slideDirection,
					layout.numOfCol, layout.cellSize, margin, layout.widthVal,
					layout.monthGap, layout.perRowCell, layout.cellGap,
					layout.x_axis_cellGap, layout.y_axis_cellGap,
					this.activeStreakIcon, this.inactiveStreakIcon, this.onCellClick, this.selectedDate,
					() => {
						// onDone callback: render the final static slice without animation
						this.isSliding = false;
						if (this._pendingSlideOnDone) {
							const cb = this._pendingSlideOnDone;
							this._pendingSlideOnDone = null;
							cb();
						} else {
							// Render the normal visible slice to snap it perfectly
							this.renderVisibleSlice(false);
						}
					}
				);
				return;
			}

			const visibleKeys = allMonthKeys.slice(this.viewOffset, this.viewOffset + visibleCount);

			const visibleKeySet = new Set(visibleKeys);
			this.streakData = this.bufferedStreakData.filter((item) => {
				const key = `${item.year}-${String(item.month).padStart(2, "0")}`;
				return visibleKeySet.has(key);
			});

			const el = document.getElementById("heatmap2");
			if (!el) return;
			el.innerHTML = "";
			const c = new profileHeatmap();
			c.heatmaps(
				this.streakData,
				layout.numOfCol, layout.cellSize, layout.cellSize, margin, layout.widthVal,
				true, layout.monthGap, layout.perRowCell, layout.cellGap,
				layout.x_axis_cellGap, layout.y_axis_cellGap,
				this.activeStreakIcon, this.inactiveStreakIcon, this.onCellClick, this.selectedDate
			);
		},
		// ── Mobile scroll heatmap ───────────────────────────────────────────────
		renderMobileScroll(scrollToEnd = false) {
			// Clamp the buffer to never show months beyond the current month.
			const now = new Date();
			const currentMonthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
			const clampedData = this.bufferedStreakData.filter(item => {
				const key = `${item.year}-${String(item.month).padStart(2, '0')}`;
				return key <= currentMonthKey;
			});

			const allKeys = [...new Set(clampedData.map(item => `${item.year}-${String(item.month).padStart(2, '0')}`))]
				.sort();
			const n = allKeys.length;
			if (!n) return;

			const layout = this.getHeatmapLayoutParams(true, n);
			const margin = { top: 10, right: 3, bottom: 8, left: 3 };

			const el = document.getElementById("heatmap2");
			if (!el) return;
			el.innerHTML = "";

			const c = new profileHeatmap();
			c.heatmaps(
				clampedData,
				layout.numOfCol, layout.cellSize, layout.cellSize, margin, layout.widthVal,
				true, layout.monthGap, layout.perRowCell, layout.cellGap,
				layout.x_axis_cellGap, layout.y_axis_cellGap,
				this.activeStreakIcon, this.inactiveStreakIcon, this.onCellClick, this.selectedDate
			);

			// Fix the SVG to a pixel width so exactly 2 months fit in the scroll container.
			// Use the container's actual clientWidth (already accounts for all card padding).
			const svgEl = el.querySelector('svg');
			const scrollContainer = document.getElementById('mobile-heatmap-scroll');
			if (svgEl && scrollContainer) {
				const containerW = scrollContainer.clientWidth || (window.innerWidth - 28);
				// Divide by 2.4 so each month is ~42% of container width,
				// fitting 2 months with breathing room (no scroll needed to see both).
				const oneMonthPx = containerW / 2.4;
				const oneMonthSvgUnits = layout.oneMonthBlockWidth || (layout.perRowCell * layout.cellSize + (layout.perRowCell - 1) * layout.x_axis_cellGap);
				const scale = oneMonthPx / oneMonthSvgUnits;
				const totalPx = Math.round(layout.widthVal * scale);
				svgEl.style.width = totalPx + 'px';
				svgEl.style.height = 'auto';
				svgEl.style.display = 'block';
				this._mobileMonthPx = Math.round(oneMonthPx + layout.monthGap * scale);
			}

			// Attach scroll listener and set initial scroll position after layout settles.
			// We use $nextTick + requestAnimationFrame to ensure the browser has applied
			// the SVG pixel width before we read scrollWidth (otherwise it may still be 0).
			this.$nextTick(() => {
				requestAnimationFrame(() => {
					const scrollEl = document.getElementById("mobile-heatmap-scroll");
					if (!scrollEl) return;

					// Remove any previous listener
					if (this._mobileScrollListener) {
						scrollEl.removeEventListener("scroll", this._mobileScrollListener);
					}
					this._mobileScrollListener = () => this.onMobileScroll(scrollEl);
					scrollEl.addEventListener("scroll", this._mobileScrollListener, { passive: true });

					// Scroll to rightmost position so current month is visible on the right
					if (scrollToEnd) {
						scrollEl.scrollLeft = scrollEl.scrollWidth;
					}

					// Initialise progress bar state
					this.mobileScrollWidth = scrollEl.scrollWidth || 1;
					this.mobileClientWidth = scrollEl.clientWidth || 1;
					this.mobileScrollLeft = scrollToEnd ? (scrollEl.scrollWidth - scrollEl.clientWidth) : scrollEl.scrollLeft;

					// Provide the element ref to the HorizontalScroll component
					this.mobileHeatmapScrollEl = scrollEl;
				});
			});
		},
				onMobileScroll(scrollEl) {
					if (!scrollEl) return;
					const sl = scrollEl.scrollLeft;
					const sw = scrollEl.scrollWidth;
					const cw = scrollEl.clientWidth;

					this.mobileScrollLeft = sl;
					this.mobileScrollWidth = sw || 1;
					this.mobileClientWidth = cw || 1;

					// Show cell shimmer on first scroll event (do NOT shimmer the activities list)
					if (!this._mobileScrolling) {
						this._mobileScrolling = true;
						const h = new profileHeatmap();
						h.applyMobileScrollShimmer();
					}

					// Edge fetches: append/prepend more months when approaching either boundary
					const threshold = 40;
					if (sl < threshold && !this._mobileScrollFetching) {
						this._doMobileFetchOlder(scrollEl);
					} else if (sl + cw > sw - threshold && !this._mobileScrollFetching && this.rightArrow) {
						this._doMobileFetchNewer(scrollEl);
					}

					// Debounced scroll-stop: remove shimmer + fetch fresh data
					if (this._mobileScrollStopTimer) clearTimeout(this._mobileScrollStopTimer);
					this._mobileScrollStopTimer = setTimeout(() => {
						this._mobileScrollStopTimer = null;
						this._mobileScrolling = false;
						// Remove cell shimmer overlay — real cells are already underneath
						const h = new profileHeatmap();
						h.removeMobileScrollShimmer();
						this._doMobileRefreshVisible(scrollEl);
					}, 500);
				},
			async _doMobileRefreshVisible(scrollEl) {
				// Don't run while a cell-click activity fetch is in flight —
				// it would overwrite the correct selectedDate render with stale data.
				if (!scrollEl || this._mobileScrollFetching || this._activityFetching) return;
				const allKeys = this.getBufferedMonthKeys();
				if (!allKeys.length) return;

				const monthPx = this._mobileMonthPx || 1;
				const sl = scrollEl.scrollLeft;
				const cw = scrollEl.clientWidth;
				const firstVisibleIdx = Math.max(0, Math.floor(sl / monthPx));
				const firstVisibleKey = allKeys[firstVisibleIdx] || allKeys[0];
				const fetchStart = this.shiftMonthKey(firstVisibleKey, -1);

				// Do NOT shimmer the activities list — the selected date hasn't changed,
				// so the activity list remains stable while the heatmap refreshes.
				try {
					const payload = { startDate: fetchStart, duration: 8, activityDate: this.selectedDate };
					const resp = await getProfileStreak(payload);
					if (resp.status === 200) {
						let rawData = Array.isArray(resp.data.data.data) ? [...resp.data.data.data] : [];
						const todayActivity = Array.isArray(resp.data.data.todayActivity) ? resp.data.data.todayActivity : [];
						if (todayActivity.length) {
							const now = new Date();
							const y = now.getFullYear(), m = now.getMonth() + 1, d = now.getDate();
							const todayCount = todayActivity.reduce((acc, i) => acc + (Number(i?.count) || 0), 0);
							const idx = rawData.findIndex(r => Number(r.year) === y && Number(r.month) === m && Number(r.day) === d);
							if (idx >= 0) rawData[idx] = { ...rawData[idx], count: Math.max(Number(rawData[idx].count) || 0, todayCount) };
							else rawData.push({ year: y, month: m, day: d, count: todayCount });
						}
						const freshChunk = this.normalizeToRecentMonths(rawData, 8, fetchStart);
						if (freshChunk.length) {
							const freshKeySet = new Set(freshChunk.map(r => `${r.year}-${String(r.month).padStart(2, '0')}`));
							const kept = this.bufferedStreakData.filter(r => !freshKeySet.has(`${r.year}-${String(r.month).padStart(2, '0')}`));
							const merged = [...kept, ...freshChunk];
							merged.sort((a, b) => {
								const ka = `${a.year}-${String(a.month).padStart(2, '0')}-${String(a.day).padStart(2, '0')}`;
								const kb = `${b.year}-${String(b.month).padStart(2, '0')}-${String(b.day).padStart(2, '0')}`;
								return ka < kb ? -1 : ka > kb ? 1 : 0;
							});
							this.bufferedStreakData = merged;
							const prevScrollLeft = scrollEl.scrollLeft;
							this.renderMobileScroll(false);
							if (scrollEl && prevScrollLeft > 0) {
								scrollEl.scrollLeft = prevScrollLeft;
								this.mobileScrollLeft = prevScrollLeft;
							}
							this.$nextTick(() => {
								const el = document.getElementById('mobile-heatmap-scroll');
								if (el) {
									el.scrollLeft = prevScrollLeft;
									this.mobileScrollLeft = el.scrollLeft;
									this.mobileScrollWidth = el.scrollWidth;
									this.mobileClientWidth = el.clientWidth;
								}
							});
						}
					}
				} catch (e) { /* silent */ }
			},
		async _doMobileFetchOlder(scrollEl) {
			if (this._mobileScrollFetching) return;
			this._mobileScrollFetching = true;

			const allKeys = this.getBufferedMonthKeys();
			const firstKey = allKeys[0];
			if (!firstKey) { this._mobileScrollFetching = false; return; }

			// Fetch 8 more months before the current buffer
			const newStartDate = this.shiftMonthKey(firstKey, -8);
			try {
				const payload = { startDate: newStartDate, duration: 8, activityDate: this.selectedDate };
				const resp = await getProfileStreak(payload);
				if (resp.status === 200) {
					let rawData = Array.isArray(resp.data.data.data) ? [...resp.data.data.data] : [];
					const newChunk = this.normalizeToRecentMonths(rawData, 8, newStartDate);
					if (newChunk.length) {
						// Prepend new months to buffer (keep at most 16 months total)
						const combined = [...newChunk, ...this.bufferedStreakData];
						// De-dupe by month key
						const seen = new Set();
						this.bufferedStreakData = combined.filter(item => {
							const k = `${item.year}-${String(item.month).padStart(2,'0')}`;
							if (seen.has(k)) return false;
							seen.add(k); return true;
						});
						if (this.bufferedStreakData.length > 16 * 31) {
							// Trim to 16 months on the right
							const trimKeys = this.getBufferedMonthKeys().slice(-16);
							const trimSet = new Set(trimKeys);
							this.bufferedStreakData = this.bufferedStreakData.filter(item => trimSet.has(`${item.year}-${String(item.month).padStart(2,'0')}`));
						}

						// Remember scroll position before re-render so we can restore it
						const prevScrollWidth = scrollEl.scrollWidth;
						const prevScrollLeft = scrollEl.scrollLeft;

						this.renderMobileScroll(false);

						this.$nextTick(() => {
							const newEl = document.getElementById("mobile-heatmap-scroll");
							if (newEl) {
								// Shift scroll right by the width of the newly prepended content
								const addedWidth = newEl.scrollWidth - prevScrollWidth;
								newEl.scrollLeft = prevScrollLeft + addedWidth;
								this.mobileScrollLeft = newEl.scrollLeft;
								this.mobileScrollWidth = newEl.scrollWidth;
								this.mobileClientWidth = newEl.clientWidth;
							}
							this._mobileScrollFetching = false;
						});
						return;
					}
				}
			} catch (e) { /* silent */ }
			this._mobileScrollFetching = false;
		},
		async _doMobileFetchNewer(scrollEl) {
			if (this._mobileScrollFetching) return;
			this._mobileScrollFetching = true;

			const allKeys = this.getBufferedMonthKeys();
			const lastKey = allKeys[allKeys.length - 1];
			if (!lastKey) { this._mobileScrollFetching = false; return; }

			const now = new Date();
			const currentMonthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2,'0')}`;
			if (lastKey >= currentMonthKey) { this._mobileScrollFetching = false; return; }

			const newStartDate = this.shiftMonthKey(lastKey, 1);
			try {
				const payload = { startDate: newStartDate, duration: 8, activityDate: this.selectedDate };
				const resp = await getProfileStreak(payload);
				if (resp.status === 200) {
					let rawData = Array.isArray(resp.data.data.data) ? [...resp.data.data.data] : [];
					const newChunk = this.normalizeToRecentMonths(rawData, 8, newStartDate);
					if (newChunk.length) {
						const combined = [...this.bufferedStreakData, ...newChunk];
						const seen = new Set();
						this.bufferedStreakData = combined.filter(item => {
							const k = `${item.year}-${String(item.month).padStart(2,'0')}`;
							if (seen.has(k)) return false;
							seen.add(k); return true;
						});

						const newKeys = this.getBufferedMonthKeys();
						const newestKey = newKeys[newKeys.length - 1] || '';
						this.rightArrow = newestKey < currentMonthKey;

						this.renderMobileScroll(false);
					}
				}
			} catch (e) { /* silent */ }
			this._mobileScrollFetching = false;
		},
		// ── End mobile scroll ────────────────────────────────────────────────────
		shiftMonthKey(monthKey, monthDelta) {
			const [year, month] = monthKey.split("-").map(Number);
			const date = new Date(year, month - 1, 1);
			date.setMonth(date.getMonth() + monthDelta);
			return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
		},
		getAnchorMonthForMobile(startDate, duration) {
			const [year, month] = startDate.split("-").map(Number);
			const date = new Date(year, month - 1, 1);
			date.setMonth(date.getMonth() + duration - 1);
			return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
		},
		_scheduleRefresh() {
			// Debounce: cancel any pending refresh and schedule a new one 500ms after last arrow press
			if (this._refreshDebounce) clearTimeout(this._refreshDebounce);
			this._refreshDebounce = setTimeout(() => {
				this._refreshDebounce = null;
				// If a slide is still running, defer until onDone fires
				if (this.isSliding) {
					this._pendingSlideOnDone = () => this._doRefreshAndDraw();
				} else {
					this._doRefreshAndDraw();
				}
			}, 500);
		},
		async _doRefreshAndDraw() {
			// Fetch fresh data for the current viewOffset, then draw static heatmap
			await this.refreshBuffer();
			this.renderVisibleSlice(false);
		},
		onPrevArrowClick() {
			if (!this.leftArrow || this.isSliding || this.loadingGraph) return;

			const isMobile = this.isMobileViewport;
			const visibleCount = isMobile ? 2 : 6;
			const allMonthKeys = this.getBufferedMonthKeys();

			if (this.viewOffset > 0) {
				this.slideDirection = "right";
				this.viewOffset -= 1;

				const now = new Date();
				const currentMonthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
				const lastVisible = allMonthKeys[this.viewOffset + visibleCount - 1] || "";
				this.rightArrow = lastVisible < currentMonthKey;

				// Disable left arrow if the new first visible month has reached the limit
				const firstVisible = allMonthKeys[this.viewOffset] || "";
				this.leftArrow = this._canGoFurther(firstVisible);

				this.isSliding = true;
				this.renderVisibleSlice(true);
				this._scheduleRefresh();
			} else {
				// Buffer exhausted — check limit before fetching more
				if (this._refreshDebounce) clearTimeout(this._refreshDebounce);

				const firstBufferedKey = allMonthKeys[0];
				// Compute what the new first visible month would be after fetching
				const newFirstVisible = firstBufferedKey
					? this.shiftMonthKey(firstBufferedKey, isMobile ? -2 : -6)
					: null;

				// If that would go past the earliest allowed month, stop
				if (newFirstVisible && !this._canGoFurther(newFirstVisible)) {
					this.leftArrow = false;
					return;
				}

				let targetMonths = [];
				for(let i=0; i<visibleCount; i++) {
					targetMonths.push(this.shiftMonthKey(firstBufferedKey, i - visibleCount + 1));
				}
				let dummyData = targetMonths.map(m => {
					let [y, mo] = m.split('-');
					return {year: y, month: mo, day: 1, count: 0};
				});

				const layout = this.getHeatmapLayoutParams(isMobile);
				const margin = isMobile ? { top: 8, right: 5, bottom: 8, left: 2 } : { top: 8, right: 5, bottom: 1, left: 2 };
				const shimmer = new profileHeatmap();
				shimmer.shimmerHeatmap(dummyData, layout.numOfCol, layout.cellSize, layout.cellSize, margin, layout.widthVal, true, layout.monthGap, layout.perRowCell, layout.cellGap, layout.x_axis_cellGap, layout.y_axis_cellGap);

				if (firstBufferedKey) {
					this.startDate = this.shiftMonthKey(firstBufferedKey, isMobile ? -2 : -6);
				}
				this.viewOffset = 1;
				this.getStreakGraph();
			}
		},
		onNextArrowClick() {
			if (!this.rightArrow || this.isSliding || this.loadingGraph) return;

			const isMobile = this.isMobileViewport;
			const visibleCount = isMobile ? 2 : 6;
			const allMonthKeys = this.getBufferedMonthKeys();
			const maxOffset = allMonthKeys.length - visibleCount;

			if (this.viewOffset < maxOffset) {
				this.slideDirection = "left";
				this.viewOffset += 1;

				const now = new Date();
				const currentMonthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
				const lastVisible = allMonthKeys[this.viewOffset + visibleCount - 1] || "";
				this.rightArrow = lastVisible < currentMonthKey;
				this.leftArrow = true;

				this.isSliding = true;
				this.renderVisibleSlice(true);
				this._scheduleRefresh();
			} else {
				// Buffer exhausted — full fetch with shimmer grid
				if (this._refreshDebounce) clearTimeout(this._refreshDebounce);
				
				const lastBufferedKey = allMonthKeys[allMonthKeys.length - 1];
				let targetMonths = [];
				for(let i=0; i<visibleCount; i++) {
					targetMonths.push(this.shiftMonthKey(lastBufferedKey, i));
				}
				let dummyData = targetMonths.map(m => {
					let [y, mo] = m.split('-');
					return {year: y, month: mo, day: 1, count: 0};
				});

				const layout = this.getHeatmapLayoutParams(isMobile);
				const margin = isMobile ? { top: 8, right: 5, bottom: 8, left: 2 } : { top: 8, right: 5, bottom: 1, left: 2 };
				const shimmer = new profileHeatmap();
				shimmer.shimmerHeatmap(dummyData, layout.numOfCol, layout.cellSize, layout.cellSize, margin, layout.widthVal, true, layout.monthGap, layout.perRowCell, layout.cellGap, layout.x_axis_cellGap, layout.y_axis_cellGap);

				if (lastBufferedKey) {
					this.startDate = this.shiftMonthKey(lastBufferedKey, -1);
				}
				this.viewOffset = 1;
				this.getStreakGraph();
			}
		},
		// Background refetch: called after a buffer-slide (desktop) to keep the buffer fresh.
		// Mobile uses _doMobileFetchOlder / _doMobileFetchNewer instead.
		async refreshBuffer() {
			const isMobile = this.isMobileViewport;
			if (isMobile) return; // mobile uses its own fetch methods
			const visibleCount = 6;
			const bufferTotal = 8;
			const allMonthKeys = this.getBufferedMonthKeys();

			// New start = 1 month before the first visible month in the new window
			const firstVisibleKey = allMonthKeys[this.viewOffset] || "";
			if (!firstVisibleKey) return;
			const newStartDate = this.shiftMonthKey(firstVisibleKey, -1);

			try {
				const payload = {
					startDate: newStartDate,
					duration: bufferTotal,
					activityDate: this.selectedDate,
				};
				const resp = await getProfileStreak(payload);
				if (resp.status === 200) {
					let rawData = Array.isArray(resp.data.data.data)
						? [...resp.data.data.data]
						: [];
					const todayActivity = Array.isArray(resp.data.data.todayActivity)
						? resp.data.data.todayActivity
						: [];
					// Patch today count as in the main flow
					if (todayActivity.length) {
						const now = new Date();
						const y = now.getFullYear(), m = now.getMonth() + 1, d = now.getDate();
						const idx = rawData.findIndex(item => Number(item.year)===y && Number(item.month)===m && Number(item.day)===d);
						const todayCount = todayActivity.reduce((acc, item) => acc + (Number(item?.count) || 0), 0);
						if (idx >= 0) rawData[idx] = { ...rawData[idx], count: Math.max(Number(rawData[idx].count)||0, todayCount) };
						else rawData.push({ year: y, month: m, day: d, count: todayCount });
					}
					const newBuffer = this.normalizeToRecentMonths(rawData, bufferTotal, newStartDate);
					if (newBuffer.length) {
						this.bufferedStreakData = newBuffer;
						// Preserve the user's current viewOffset by finding where firstVisibleKey
						// landed in the new buffer. Fall back to 1 if not found.
						const newKeys = this.getBufferedMonthKeys();
						const restoredIdx = newKeys.indexOf(firstVisibleKey);
						this.viewOffset = restoredIdx >= 0 ? restoredIdx : 1;
						// Update arrow states
						const now = new Date();
						const currentMonthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
						const lastVisible = newKeys[this.viewOffset + visibleCount - 1] || "";
						const firstVisible = newKeys[this.viewOffset] || "";
						this.rightArrow = lastVisible < currentMonthKey;
						this.leftArrow = this.viewOffset > 0 && this._canGoFurther(firstVisible);
					}
				}
			} catch (e) {
				// Silent — the user already sees the correct data from the buffer slice
			}
		},
		formatDateStreak(data) {
			if (data) {
				const { month, year, day } = data;
				// Create a date object
				const date = new Date(year, month - 1, day); // month is 0-indexed
				// Format to "Oct, 2024"
				const months = date.toLocaleDateString("en-US", { month: "short" });
				const years = date.toLocaleDateString("en-US", { year: "numeric" });
				//   return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
				return `${months}, ${years}`;
			}
		},
		arrowClick(myStreakData, getNum) {
			this.shimmerStreak = true;
			const num = getNum;
			this.startDate = this.getSixMonthsBackDate(
				myStreakData.year,
				myStreakData.month,
				num
			);
			this.getStreakGraph();
		},
		handleViewportResize() {
			const nextIsMobile = this.isMobileStreakView();
			if (nextIsMobile !== this.isMobileViewport) {
				this.isMobileViewport = nextIsMobile;
				this.shimmerStreak = true;
				this.getStreakGraph();
			}
		},
		getSixMonthsBackDate(year, month, theMonth) {
			let date = new Date(year, month);
			date.setMonth(date.getMonth() - theMonth);
			// Get the new year and month
			let newYear = date.getFullYear();
			let newMonth = (date.getMonth() + 1).toString().padStart(2, "0");
			return `${newYear}-${newMonth}`;
		},
		firstDate() {
			if (this.isMobileViewport) {
				// Mobile scroll shows 8 months in a horizontal strip. Start 7 months back so the
				// strip spans [7 months ago → current month] = 8 months total.
				let date = new Date();
				date.setMonth(date.getMonth() - 7);
				return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}`;
			}
			// Desktop shows 6 months visible + 1 left buffer + 1 right buffer = 8 months.
			// Start 6 months ago so buffer[0] = 6 months ago, visible = months 1-6, buffer[7] = current month.
			let date = new Date();
			date.setMonth(date.getMonth() - 6);
			return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}`;
		},
		normalizeToRecentMonths(rows, monthLimit = 7, anchorDate = null) {
			if (!Array.isArray(rows) || rows.length === 0) {
				return [];
			}

			const groupedByMonth = rows.reduce((acc, item) => {
				const key = `${item.year}-${String(item.month).padStart(2, "0")}`;
				if (!acc[key]) {
					acc[key] = [];
				}
				acc[key].push(item);
				return acc;
			}, {});

			let maxMonth;
			if (anchorDate) {
				// Anchor exactly on the end of the requested window (startDate + monthLimit - 1)
				const [year, month] = anchorDate.split("-").map(Number);
				maxMonth = new Date(year, month - 1 + (monthLimit - 1), 1);
			} else {
				maxMonth = rows.reduce((latest, item) => {
					const current = new Date(item.year, item.month - 1, 1);
					return current > latest ? current : latest;
				}, new Date(rows[0].year, rows[0].month - 1, 1));
			}

			// Never allow maxMonth to exceed the current month
			const nowClamp = new Date();
			const currentMonthCap = new Date(nowClamp.getFullYear(), nowClamp.getMonth(), 1);
			if (maxMonth > currentMonthCap) {
				maxMonth = currentMonthCap;
			}

			const targetMonths = Array.from({ length: monthLimit }, (_, idx) => {
				const date = new Date(maxMonth.getFullYear(), maxMonth.getMonth() - idx, 1);
				return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
			});

			const result = targetMonths.flatMap((monthKey) => {
				if (groupedByMonth[monthKey] && groupedByMonth[monthKey].length) {
					return groupedByMonth[monthKey];
				}
				const [year, month] = monthKey.split("-").map(Number);
				return [{ year, month, day: 1, count: 0 }];
			});

			// Reverse order so oldest month appears on left (chronological order)
			const uniqueMonthKeys = [];
			result.forEach((item) => {
				const key = `${item.year}-${String(item.month).padStart(2, "0")}`;
				if (!uniqueMonthKeys.includes(key)) {
					uniqueMonthKeys.push(key);
				}
			});

			const reversedResult = [];
			for (let i = uniqueMonthKeys.length - 1; i >= 0; i--) {
				const monthKey = uniqueMonthKeys[i];
				result.forEach((item) => {
					const itemKey = `${item.year}-${String(item.month).padStart(2, "0")}`;
					if (itemKey === monthKey) {
						reversedResult.push(item);
					}
				});
			}

			return reversedResult;
		},
			async getStreakGraph(isActivityOnly = false) {
				if (isActivityOnly) this._activityFetching = true;
				const isMobile = this.isMobileViewport;
			// Desktop: 8-month buffer (1 left + 6 visible + 1 right).
			// Mobile: 8-month scroll strip (all rendered at once, no virtual window).
			const visibleCount = isMobile ? 8 : 6;
			const bufferTotal = 8;
			const monthLimit = bufferTotal;

			// For mobile full loads, always re-anchor startDate to today so the
			// buffer always ends at the current month.
			if (isMobile && !isActivityOnly) {
				this.startDate = this.firstDate();
			}

			// When triggered from a cell click, do NOT wipe data early.
			// Let the API response overwrite the data, preventing UI flashing.
			if (!isActivityOnly) {
				// We don't wipe this.bufferedStreakData here because it would
				// break the UI state while loading.
				this.streakData = [];
			}

			try {
				let payload = {
					startDate: this.startDate,
					duration: monthLimit,
					activityDate: this.selectedDate,
				};

				const resp = await getProfileStreak(payload);
				if (resp.status == 200) {
						this.monthKey = resp.data.data.noOfMonth;
					// Capture account creation date from API on first load
					if (!this.accountCreatedAt && resp.data.data.accountCreatedAt) {
						this.accountCreatedAt = resp.data.data.accountCreatedAt;
						this._computeEarliestAllowedMonth();
					}
					let storedKey = localStorage.getItem("streakKey");
					if (this.monthKey !== storedKey) {
						localStorage.setItem("streakKey", this.monthKey);
					}

					this.storedKey = localStorage.getItem("streakKey");
					let rawData = Array.isArray(resp.data.data.data)
						? [...resp.data.data.data]
						: [];
					const todayActivity = Array.isArray(resp.data.data.todayActivity)
						? resp.data.data.todayActivity
						: [];
					// Compute today's total using same grouping rules as StreakCard
					const COUNT_TYPES = new Set([42, 43, 44, 45, 52]);
					const NO_COUNT_TYPES = new Set([33, 37, 47, 50, 25, 26, 41]);
					const NO_DISPLAY_TYPES = new Set([]);
					const RESUME_START = 1;
					const RESUME_END = 21;
					let todayTotal = 0;
					const seenNoCount = new Set();
					const statsMap = new Map();

					for (const item of todayActivity) {
						if (!item) continue;
						const raw = Number(item?.count);
						const logTypeRaw = Number(item?.logType);
						const labelFromAPI = item?.label;
						const triggeredLogCount = Array.isArray(item?.triggeredLogTypes)
							? item.triggeredLogTypes.length
							: 0;
						const doneFlag = item?.done === true;
						const triggeredCount =
							Number.isFinite(raw) && raw > 0
								? raw
								: triggeredLogCount > 0
								? triggeredLogCount
								: doneFlag
								? 1
								: 0;
						if (triggeredCount === 0) continue;
						
						const labelLower = (labelFromAPI || "").toLowerCase();
						let showCount = false;
						let count = triggeredCount;
						let label = labelFromAPI || null;
						let groupKey = null;
						const logType = Number.isFinite(Number(logTypeRaw)) ? Number(logTypeRaw) : null;

						if (NO_DISPLAY_TYPES.has(logType)) {
							todayTotal += triggeredCount;
							continue;
						}

						if (logType !== null) {
							if (logType >= RESUME_START && logType <= RESUME_END) {
								groupKey = "resume";
								showCount = false;
								count = 1;
								label = "Resume updated";
							} else if (NO_COUNT_TYPES.has(logType)) {
								if (logType === 25 || logType === 26) {
									groupKey = "secondary_profile";
								} else {
									groupKey = `lt_${logType}`;
								}
								showCount = false;
								count = 1;
								label = label || this.getActivityLabel({ logType, count: 1 });
							} else if (COUNT_TYPES.has(logType)) {
								groupKey = `lt_${logType}`;
								showCount = true;
								count = triggeredCount;
								label = label || this.getActivityLabel({ logType, count });
							} else {
								groupKey = `lt_${logType}`;
								showCount = triggeredCount > 0;
								count = triggeredCount;
								label = label || this.getActivityLabel({ logType, count });
							}
						} else {
							if (/resume|cv|cvs?/.test(labelLower)) {
								groupKey = "resume";
								showCount = false;
								count = 1;
								label = "Resume updated";
							} else if (/new profile/.test(labelLower)) {
								groupKey = "new_profile";
								showCount = false;
								count = 1;
								label = "New profile created";
							} else if (/secondary profile|secondary/.test(labelLower)) {
								groupKey = "secondary_profile";
								showCount = false;
								count = 1;
								label = "Secondary profile created";
							} else if (/video snapshot|snapshot/.test(labelLower)) {
								groupKey = "video_snapshot";
								showCount = false;
								count = 1;
								label = "Video snapshot created";
							} else if (/panelist|applied as panelist|panelist application/.test(labelLower)) {
								groupKey = "panelist";
								showCount = false;
								count = 1;
								label = "Panelist application submitted";
							} else if (/assessment/.test(labelLower)) {
								groupKey = "label_assessment";
								showCount = true;
								count = triggeredCount;
								label = this.getActivityLabel({ logType: 42, count });
							} else {
								showCount = triggeredCount > 0;
								count = triggeredCount;
								groupKey = "label_" + (labelFromAPI || Math.random()).toLowerCase();
								label = label || this.getActivityLabel({ logType: null, count });
							}
						}

						if (showCount) {
							todayTotal += count;
						} else {
							if (!seenNoCount.has(groupKey)) {
								todayTotal += 1;
								seenNoCount.add(groupKey);
							}
						}

						const mapKey = groupKey || (label || "").toLowerCase();
						const existing = statsMap.get(mapKey);
						if (existing) {
							if (existing.showCount) {
								existing.count += count;
							}
						} else {
							statsMap.set(mapKey, { count, label, showCount, logType });
						}
					}

					let finalStats = Array.from(statsMap.values()).map((entry) => {
						if (entry.showCount && Number.isFinite(entry.logType)) {
							const cnt = entry.count;
							const lbl = this.getActivityLabel({ logType: entry.logType, count: cnt });
							return { count: cnt, label: lbl, showCount: true, logType: entry.logType };
						} else if (entry.showCount) {
							return { count: entry.count, label: entry.label, showCount: true, logType: entry.logType };
						}
						return { count: entry.count, label: String(entry.label).replace(/\b\w/g, c => c.toUpperCase()), showCount: false, logType: entry.logType };
					});

					// If the heatmap indicates more activities than the API returned
					// in the list, artificially inject a "Signed in" activity to make up the difference.
					if (this.selectedDate) {
						const [sYear, sMonth, sDay] = this.selectedDate.split('-').map(Number);
						const heatmapDay = rawData.find(item => Number(item.year) === sYear && Number(item.month) === sMonth && Number(item.day) === sDay) 
										|| this.bufferedStreakData.find(item => Number(item.year) === sYear && Number(item.month) === sMonth && Number(item.day) === sDay);
						
						const heatmapCount = heatmapDay ? Number(heatmapDay.count) : 0;
						if (heatmapCount > todayTotal) {
							const diff = heatmapCount - todayTotal;
							finalStats.push({ count: diff, label: "Signed in", showCount: false, logType: 41 });
							todayTotal = heatmapCount;
						}
					}

					this.stats = finalStats;
					this.todayTotalCount = todayTotal;
					
					if (todayTotal > 0) {
						const now = new Date();
						const y = now.getFullYear();
						const m = now.getMonth() + 1;
						const d = now.getDate();
						const idx = rawData.findIndex(
							(item) =>
								Number(item.year) === y &&
								Number(item.month) === m &&
								Number(item.day) === d
						);
						if (idx >= 0) {
							rawData[idx] = {
								...rawData[idx],
								count: Math.max(Number(rawData[idx].count) || 0, todayTotal),
							};
						} else {
							rawData.push({ year: y, month: m, day: d, count: todayTotal });
						}
					}
					if (isActivityOnly) {
						// Cell click: keep the existing buffer intact so the heatmap
						// doesn't lose months the user has scrolled to. Only merge the
						// fresh rawData on top of the buffer for any overlapping days.
						if (rawData.length) {
							const freshByKey = {};
							rawData.forEach(r => {
								const k = `${r.year}-${String(r.month).padStart(2,'0')}-${String(r.day).padStart(2,'0')}`;
								freshByKey[k] = r;
							});
							this.bufferedStreakData = this.bufferedStreakData.map(r => {
								const k = `${r.year}-${String(r.month).padStart(2,'0')}-${String(r.day).padStart(2,'0')}`;
								return freshByKey[k] ? { ...r, count: freshByKey[k].count } : r;
							});
						}
					} else {
						// Full load: replace the entire buffer
						this.bufferedStreakData = this.normalizeToRecentMonths(
							rawData,
							monthLimit,
							this.startDate
						);
					}

					// viewOffset = 2: skip the 2 left-buffer months, show months 2..7 (desktop only)
					// This ensures the current month (rightmost) is the last visible month on initial load.
					if (!isActivityOnly && !isMobile) {
						this.viewOffset = 2;
					}

					// Compute arrow states
					const allMonthKeys = this.getBufferedMonthKeys();
					const now2 = new Date();
					const currentMonthKey = `${now2.getFullYear()}-${String(now2.getMonth() + 1).padStart(2, "0")}`;
					if (!isMobile) {
						const lastVisible = allMonthKeys[this.viewOffset + visibleCount - 1] || "";
						const firstVisible = allMonthKeys[this.viewOffset] || "";
						this.leftArrow = this._canGoFurther(firstVisible);
						this.rightArrow = lastVisible < currentMonthKey;
					} else {
						// Mobile: never fetch future months — rightArrow always false
						this.rightArrow = false;
						const firstVisible = allMonthKeys[this.viewOffset] || "";
						this.leftArrow = this._canGoFurther(firstVisible);
					}

					this.streakMonthCount = visibleCount;

					setTimeout(() => {
						// If a cell was clicked, use _scrollToDateAfterRender to
						// scroll the heatmap (desktop or mobile) to that month.
						const scrollTarget = this._scrollToDateAfterRender || null;
						this._scrollToDateAfterRender = null;

						if (isMobile) {
							const scrollEl = document.getElementById('mobile-heatmap-scroll');
							const prevScrollLeft = scrollEl ? scrollEl.scrollLeft : 0;

							this.renderMobileScroll(false);
							if (scrollEl && prevScrollLeft > 0) {
								scrollEl.scrollLeft = prevScrollLeft;
								this.mobileScrollLeft = prevScrollLeft;
							}
							this.$nextTick(() => {
								requestAnimationFrame(() => {
									const el = document.getElementById('mobile-heatmap-scroll');
									if (el) {
										if (scrollTarget) {
											// Scroll to the clicked month
											const targetMonthKey = scrollTarget.substring(0, 7);
											this._scrollMobileToMonth(targetMonthKey);
										} else if (!isActivityOnly) {
											// Fresh load with no specific date target: scroll to end
											el.scrollLeft = el.scrollWidth;
											this.mobileScrollLeft = el.scrollLeft;
										} else {
											// Activity-only with no target: preserve position
											el.scrollLeft = prevScrollLeft;
											this.mobileScrollLeft = el.scrollLeft;
										}
										this.mobileScrollWidth = el.scrollWidth;
										this.mobileClientWidth = el.clientWidth;
									}
									this._mobileTargetScrollIdx = null;
									this.releaseScrollLock();
								});
							});
					} else {
						// Desktop: if we have a scroll target, adjust viewOffset
						// so the target month is the rightmost visible month.
						if (scrollTarget) {
							const targetMonthKey = scrollTarget.substring(0, 7);
							const desktopKeys = this.getBufferedMonthKeys();
							const tIdx = desktopKeys.indexOf(targetMonthKey);
							if (tIdx !== -1) {
								const vCount = 6;
								const idealOff = tIdx - vCount + 1;
								this.viewOffset = Math.max(0, Math.min(desktopKeys.length - vCount, idealOff));
								// Update arrow states after viewOffset change
								const nowD = new Date();
								const curKey = `${nowD.getFullYear()}-${String(nowD.getMonth() + 1).padStart(2, "0")}`;
								const lastV = desktopKeys[this.viewOffset + vCount - 1] || "";
								const firstV = desktopKeys[this.viewOffset] || "";
								this.rightArrow = lastV < curKey;
								this.leftArrow = this._canGoFurther(firstV);
							}
						}
						this.renderVisibleSlice();
						this.releaseScrollLock();
					}
					}, 100);
				} else {
					console.log("APi Error");
					this.releaseScrollLock();
				}
			} catch (error) {
				console.log(error);
				this.releaseScrollLock();
			}
			this.shimmerStreak = false;
			this.shimmerActivities = false;
			if (isActivityOnly) {
				this._activityFetching = false;
			}
		},
		releaseScrollLock() {
			let p = this.$parent;
			while (p) {
				if (typeof p.lockScrollState === 'function') {
					p.lockScrollState(0);
					break;
				}
				p = p.$parent;
			}
		},
	},
};
</script>

<style>
/* ── Heatmap slide wrapper & overlay arrows ── */
.heatmap-slide-wrapper {
	position: relative;
	width: 100%;
}

/* Clip box fills the full wrapper width.
   overflow:hidden clips the 7-month slide SVG to exactly 6 months. */
.heatmap-clip-box {
	overflow: hidden;
	width: 100%;
	/* Inset the clip area slightly on each side so arrows overlay the edge cells
	   (matching the reference image). */
	padding: 0 4px;
	box-sizing: border-box;
}

/* The SVG rendered inside #heatmap2 must NOT clip itself */
#heatmap2 svg {
	overflow: visible;
}

/* Arrow buttons: absolutely positioned over the clip box, centred vertically */
.heatmap-arrow {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 10;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #fff;
	border: 1px solid #e2e8f0;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: box-shadow 0.15s ease, opacity 0.15s ease;
	padding: 0;
}
.heatmap-arrow:hover:not(:disabled) {
	box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
}
.heatmap-arrow:disabled {
	opacity: 0.35;
	cursor: default;
	pointer-events: none;
}
/* Left arrow sits at the very left edge of the wrapper, overlapping the clip box */
.heatmap-arrow-left  { left: 0; }
/* Right arrow sits at the very right edge of the wrapper, overlapping the clip box */
.heatmap-arrow-right { right: 0; }

/* Streak activity pagination buttons */
.streak-page-btn {
	outline: none !important;
	box-shadow: none !important;
}
.streak-page-btn:disabled {
	cursor: not-allowed !important;
	pointer-events: all !important;
}

.streaks-card {
	box-shadow: 0px 4px 8px 0px #0000002b;
	background-color: var(--bg-white);
	border-radius: 8px;
	display: flex;
	justify-content: space-between;
	padding: 20px;
	width: 100%;
}
.streak-head {
	font-family: "Montserrat", sans-serif;
	font-size: 16.05px;
	font-weight: 500;

	color: #3a3c40;
}
.activity-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 11px;
	font-weight: 600;
	color: #333333;
}

.greyShadow {
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	border-radius: 50%;
}
.dotted-bottom {
	border-bottom: 2px dashed #e2e8f0;
	padding-bottom: 16px;
}

@media (max-width: 768px) {
	.streaks-card {
		padding: 14px;
		min-height: auto !important;
	}

	#heatmap2 {
		padding-left: 0 !important;
	}
}

/* ── Mobile scroll heatmap ── */
.mobile-heatmap-scroll {
	width: 100%;
	overflow-x: scroll;
	overflow-y: hidden;
	-webkit-overflow-scrolling: touch;
	/* Hide native scrollbar on all browsers */
	scrollbar-width: none;        /* Firefox */
	-ms-overflow-style: none;     /* IE/Edge */
}
.mobile-heatmap-scroll::-webkit-scrollbar {
	display: none;                /* Chrome/Safari */
}

.mobile-heatmap-inner {
	/* Let the div shrink-wrap to the SVG's fixed pixel width so it overflows the scroll container */
	display: inline-block;
	white-space: nowrap;
	/* Prevent any min-width from collapsing the strip */
	min-width: 0;
}
.mobile-heatmap-inner svg {
	overflow: visible;
	display: block;
	/* height is auto; width is set programmatically by renderMobileScroll */
}

/* Wrapper for the HorizontalScroll slider used under the mobile heatmap */
.mobile-heatmap-slider-wrap {
	width: 60%;
	max-width: 180px;
	margin: 8px auto 0;
}

/* ── Activity list shimmer — same sweep as heatmap cells ── */
@keyframes streak-shimmer-sweep {
	0%   { background-position: -400px 0; }
	100% { background-position:  400px 0; }
}
.act-shimmer-circle,
.act-shimmer-line {
	background: linear-gradient(
		90deg,
		#e8edf2 25%,
		#f5f7fa 50%,
		#e8edf2 75%
	);
	background-size: 800px 100%;
	animation: streak-shimmer-sweep 1.4s ease-in-out infinite;
	border-radius: 4px;
}
.act-shimmer-circle {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	flex-shrink: 0;
}
.act-shimmer-line {
	height: 14px;
	border-radius: 6px;
}
</style>
